const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export function getSupabaseConfig(): { url: string; anonKey: string } {
  if (!url?.trim() || !anonKey?.trim()) {
    throw new Error("missing_config");
  }
  return { url: url.replace(/\/$/, ""), anonKey: anonKey.trim() };
}

export const CONSENT_TEXT_VERSION = "storybook_v1";
export const MIN_RESPONSE_CHARS = 12;
